import React, { Component } from 'react'
// import { Col, Row, Spinner, Modal, ModalBody, Button, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import {
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Spinner,
} from 'reactstrap'
import { withFirebase } from '../Fb'
import moment from 'moment'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import Tabs from '@mui/material/Tabs'
import Grid from '@mui/material/Grid'
import Tab from '@mui/material/Tab'
import IconButton from '@mui/material/IconButton'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import InputAdornment from '@mui/material/InputAdornment'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import CircularProgress from '@mui/material/CircularProgress'
import { ListItem, Typography, ListItemText, ListItemSecondaryAction, Divider, Avatar, Switch, Autocomplete } from '@mui/material'
// import TabPanel from '@mui/lab/TabPanel'
import WarningIcon from '@mui/icons-material/Warning'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import ActivityCreator from './ActivityCreator'
import MembershipPricesEditor, { membershipLabel, effectiveMembershipPrice, rowPriceType, PRICETYPE_DISCOUNT } from '../Inputs/MembershipPricesEditor'
import ExtraInfoQuestionsEditor from '../Inputs/ExtraInfoQuestionsEditor'
import ActivityReservations from './ActivityReservations'
import Tooltip from '@mui/material/Tooltip'
import ActivityTimeRange from '../Inputs/ActivityTimeRange'
import DateTimeSelect from '../Inputs/DateTimeSelect'
import PadelutionTournamentDialog from '../Dialogs/PadelutionTournamentDialog'
import ActivityParticipantExtraInfoDialog from '../Dialogs/ActivityParticipantExtraInfoDialog'
import ActivityReservationSyncDialog from '../Dialogs/ActivityReservationSyncDialog'
import ActivityReservationReleaseDialog from '../Dialogs/ActivityReservationReleaseDialog'
import { driftedReservations, createdReservations } from '../utils/activityReservations'
import { ORGANISER_NOTIFICATION_OPTIONS, getOrganiserNotification } from '../utils/activityNotifications'
import {
  cancellationEndError,
  effectiveCancellationEnd,
  hasOwnCancellationEnd,
} from '../utils/activityCancellationDeadline'
import { templateFromActivity } from '../utils/activityTemplates'
import { personPath } from '../utils/links'
import { TIMING_FIELDS, applyTiming, futureOccurrences, templateTiming, timingFromEdited } from '../utils/recurrentTiming'
import { Link as RouterLink } from 'react-router-dom'
import EditIcon from '@mui/icons-material/Edit'
import algoliasearch from 'algoliasearch'
import DeleteButton from '../Buttons/DeleteButton'
import { DataGrid, GridToolbarExport, GridToolbarContainer } from '@mui/x-data-grid'
import MoveButton from '../Buttons/MoveButton'
import CheckInoutButton from '../Buttons/CheckInOutButton'
import AddPaymentButton from '../Buttons/AddPaymentButton'
import ActivityPaymentDialog from '../Dialogs/ActivityPaymentDialog'
import ActivityRemoveDialog from '../Dialogs/ActivityRemoveDialog'
import PersonSearch from '../Inputs/PersonSearch'
import ImageSelector from '../Inputs/ImageSelector'
import MessageDialog from '../Editor/MessageDialog'
import RecurrentEditDialog from '../Dialogs/RecurrentEditDialog'

const DISABLED_VAT_OPTIONS = [10, 14, 24]

const ACL_FIELDS = ['allowpostpayment', 'blocked', 'blockedMessage']
const GENDERS = [
  { label: 'Avoin', value: 'open' },
  { label: 'Miehet', value: 'men' },
  { label: 'Naiset', value: 'female' },
]
const STATES = [
  { label: 'Luonnos', value: 'draft' },
  { label: 'Julkaistu', value: 'published' },
  { label: 'Peruttu', value: 'cancelled' },
  { label: 'Poistettu', value: 'deleted' },
]

const paymenttypes = [
  {
    value: 'transfer',
    label: 'Siirto',
  },
  {
    value: 'compensation',
    label: 'Hyvitys',
  },
  {
    value: 'deposit',
    label: 'Talletus',
  },
]

const algoliaclient = algoliasearch('6WV1D95IXL', 'd7e7d2238757ecd7bfd520b2b3a5562f')
const algoliaindex = algoliaclient.initIndex('falcon_combined')

function objectsAreSame(x, y) {
  var objectsAreSame = true
  for (var propertyName in x) {
    if (x[propertyName] !== y[propertyName]) {
      objectsAreSame = false
      break
    }
  }
  return objectsAreSame
}

const arraysEqual = (a1, a2) => a1.length === a2.length && a1.every((o, idx) => objectsAreSame(o, a2[idx]))

// The form edits this copy, never the parent's activity. Editing the parent's object in place
// showed an edited time in the lists as if saved, also when the save was cancelled or failed.
// The handlers set top-level fields and one level down (name.fi), so plain objects and arrays
// are copied one level deep; class instances such as Firestore Timestamps are kept as they are.
const editableCopy = (activity) => {
  if (!activity) return activity
  const copy = {}
  Object.keys(activity).forEach((key) => {
    const value = activity[key]
    if (Array.isArray(value)) copy[key] = [...value]
    else if (value && Object.getPrototypeOf(value) === Object.prototype) copy[key] = { ...value }
    else copy[key] = value
  })
  return copy
}

// The recurrent callables catch their own errors and answer { status: 'ERROR' } rather than
// failing the call.
const throwOnCallableError = (response) => {
  const data = response && response.data
  if (data && data.status === 'ERROR') throw new Error(data.message || 'unknown error')
  return response
}

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <React.Fragment>{children}</React.Fragment>}
    </div>
  )
}

function EditIconButton(props) {
  return (
    <IconButton aria-label='Muokkaa' onClick={props.onClick}>
      <EditIcon />
    </IconButton>
  )
}

function ExportToolbar({ name, date, suffix }) {
  let _suffix = suffix || 'activity'
  let safename = ''
  if (name) {
    safename = name.replace(/[^a-z0-9]/gi, '_').toLowerCase() + '-'
  }
  if (date) {
    safename += moment(date, 'YYYY-MM-DDTHH:mm').format('YYYY-MM-DD') + '-'
  }

  return (
    <GridToolbarContainer>
      <GridToolbarExport
        csvOptions={{
          fileName: safename + _suffix,
          delimiter: ';',
          utf8WithBom: true,
        }}
      />
    </GridToolbarContainer>
  )
}

const clearAlgolia = (x) => {
  x.id = x.objectID
  delete x._highlightResult
  delete x.lastmodified
  delete x.reservationAlert
  delete x.objectID
  return x
}

// Up to this many extra-info questions get a column each; beyond it they share one.
const EXTRAINFO_COLUMN_LIMIT = 2
const SEPARATOR = ' · '

class ActivityDetailsWizard extends Component {
  constructor(props) {
    super(props)
    this.originalStart = props.activity ? props.activity.start : null
    this.state = {
      loading: true,
      reservationModalOpen: false,
      loadingModalOpen: false,
      reservations: [],
      formattedReservations: [],
      saldoloading: true,
      storageloading: true,
      membershipsloading: true,
      membershippermanent: false,
      aclsloading: true,
      acls: {},
      showAddMembershipRow: false,
      venues: [],
      activeTab: '1',
      removePersonConfirmation: false,
      saldodescription: null,
      saldotype: null,
      saldowallet: null,
      saldovenue: null,
      saldoamount: 0,
      savingsaldo: false,
      storagedescription: null,
      storagetype: null,
      storagewallet: null,
      storagevenue: null,
      storageamount: 0,
      savingstorage: false,
      tabValue: 0,
      messages: [],
      messagesloading: true,
      messageopen: [],
      messaging: { isOpen: false },
      copied: false,
      passwordResetLink: '',
      edits: {
        nameEditOpen: false,
      },
      activityEdits: {},
      activity: editableCopy(this.props.activity),
      newparticipant: [],
      newqueued: [],
      sports: this.props.sports,
      activitytypes: this.props.activitytypes,
      priceInputs: {
        price: this.props.activity && this.props.activity.price ? this.props.activity.price.toFixed(2) : '0.00',
      },
      recurrentEditDialogOpen: false,
      recurrentEditLoading: false,
      recurrentEditError: null,
      saveError: null,
      memberships: [],
      driftDialogActivity: null,
      driftedList: [],
      movingReservations: false,
      releaseDialogOpen: false,
      releasing: false,
      padelutionDialogOpen: false,
      extraInfoDialogOpen: false,
      // Set by Tallenna ja sulje; see handleSave/maybeClose.
      pendingClose: false,
    }
  }

  componentDidMount() {
    // console.log('mount')
    // this.getReservations(this.props.person.id)
    // this.getSaldo(this.props.person.id)
    this.updateData()
    this.setState({ tabValue: this.props.initTab || 0 })
    this.getMemberships()
  }

  getMemberships = () => {
    this.props.firebase
      .getMemberships()
      .then((snap) => {
        const memberships = snap.empty ? [] : snap.docs.map((d) => ({ id: d.id, ...d.data() }))
        this.setState({ memberships })
      })
      .catch((error) => console.error(error))
  }

  // The occurrence's start as stored, before any edit. "This and all future" counts from it, not
  // from the edited start in state.activity. After a save it is the saved start, until the parent
  // refetches and passes the saved activity in.
  rememberOriginalStart = () => {
    this.originalStart = this.props.activity ? this.props.activity.start : null
  }

  hasActivityEdits = () => Object.values(this.state.activityEdits || {}).some((value) => value)

  componentDidUpdate(prevProps) {
    if (this.props.activity !== prevProps.activity && !this.hasActivityEdits()) {
      this.rememberOriginalStart()
    }
    if (this.props.initTab !== prevProps.initTab) {
      this.setState({ tabValue: this.props.initTab })
    }
    if (this.props.activity && prevProps.activity) {
      const participants = this.props.activity.participants || []
      const prevParticipants = prevProps.activity.participants || []
      const queue = this.props.activity.queue || []
      const prevQueue = prevProps.activity.queue || []
      // payments[] too: adding one touches neither participants nor queue, so without this
      // the Maksettu and Maksutapa columns kept showing what was loaded when the wizard
      // opened, however many times the parent refetched.
      const payments = this.props.activity.payments || []
      const prevPayments = prevProps.activity.payments || []
      // check if participants, queue or payments changed
      if (
        arraysEqual(participants, prevParticipants) &&
        arraysEqual(queue, prevQueue) &&
        arraysEqual(payments, prevPayments)
      ) {
        return
      }
      this.updateData()
    }
  }

  updateData = () => {
    if (!this.hasActivityEdits()) this.rememberOriginalStart()
    const activity = editableCopy(this.props.activity)
    if (activity && (activity.vat === undefined || activity.vat === null || activity.vat === '')) {
      activity.vat = 13.5
    }
    this.setState({
      loading: false,
      activity,
      activityEdits: {},
      edits: {},
      checkin: {},
      paymentParticipant: null,
      removeTarget: null,
      removeError: null,
    })
  }

  handleTextChange = (e, property) => {
    // console.log('handleTextChange', e.target.value, property)
    const { activity } = this.state
    if (property.indexOf('.') > -1) {
      const [parent, child] = property.split('.')
      activity[parent][child] = e.target.value
    } else {
      activity[property] = e.target.value
    }
    this.setState({ activity, activityEdits: { ...this.state.activityEdits, [property]: true } })
  }

  // membershipPrices/extrainfo are arrays owned by their editor components, so they
  // bypass the event-shaped handlers but use the same dirty tracking as everything else.
  handleArrayChange = (value, property) => {
    const { activity } = this.state
    activity[property] = value
    this.setState({ activity, activityEdits: { ...this.state.activityEdits, [property]: true } })
  }

  // Inputs that emit a value rather than a DOM event (DateTimeSelect).
  handleValueChange = (value, property) => {
    const { activity } = this.state
    activity[property] = value
    this.setState({ activity, activityEdits: { ...this.state.activityEdits, [property]: true } })
  }

  // ActivityTimeRange sets both ends at once.
  handleTimeRangeChange = ({ start, end }) => {
    const { activity } = this.state
    activity.start = start
    activity.end = end
    this.setState({ activity, activityEdits: { ...this.state.activityEdits, start: true, end: true } })
  }

  handlePriceChange = (e, property) => {
    const { priceInputs } = this.state
    priceInputs[property] = e.target.value
    this.setState({ priceInputs, activityEdits: { ...this.state.activityEdits, [property]: true } })
  }

  handleNumberChange = (e, property) => {
    const { activity } = this.state
    if (typeof e.target.value !== 'number') {
      let value = e.target.value
      if (value.indexOf(',') > -1) {
        value = value.replace(',', '.')
      }
      value = value.replace(/[^0-9.]/g, '')
      if (property.indexOf('.') > -1) {
        const [parent, child] = property.split('.')
        activity[parent][child] = parseFloat(value)
      } else {
        activity[property] = parseFloat(value)
      }
    } else {
      if (property.indexOf('.') > -1) {
        const [parent, child] = property.split('.')
        activity[parent][child] = e.target.value
      } else {
        activity[property] = e.target.value
      }
    }
    this.setState({ activity, activityEdits: { ...this.state.activityEdits, [property]: true } })
  }

  handleSwitchChange = (e, property) => {
    const { activity } = this.state
    if (property.indexOf('.') > -1) {
      const [parent, child] = property.split('.')
      activity[parent][child] = e.target.checked
    } else {
      activity[property] = e.target.checked
    }
    this.setState({ activity, activityEdits: { ...this.state.activityEdits, [property]: true } })
  }

  handlePosterChange = (e) => {
    const { activity } = this.state
    const _image = this.props.images.find((image) => image.id === e.target.value)
    activity.poster = _image.url
    activity.media = _image
    this.setState({ activity, activityEdits: { ...this.state.activityEdits, poster: true } }, this.togglePosterEdit)
  }

  togglePosterEdit = () => {
    this.setState({ edits: { ...this.state.edits, posterEditOpen: !this.state.edits.posterEditOpen } })
  }

  setEditState = (property, value) => {
    this.setState({ edits: { ...this.state.edits, [property]: value } })
  }

  // Own deadline for cancelling a participation (docs/features/activity-cancellation-deadline.md).
  // Off, it follows the entry end; turned on, it starts from the entry end.
  toggleCancellationEnd = (e) => {
    this.handleValueChange(e.target.checked ? this.state.activity.entryend : null, 'cancellationend')
  }

  // closeAfter comes from which button was pressed: Tallenna stays put, Tallenna ja sulje
  // returns to the list. It is held in state rather than threaded through, because the save
  // can detour via the recurrent-scope dialog before it reaches performSave.
  handleSave = async (closeAfter) => {
    const { activity } = this.state
    if (!hasOwnCancellationEnd(activity) && activity.cancellationend !== undefined) activity.cancellationend = null
    this.setState({ pendingClose: !!closeAfter })

    // Check if this is a recurrent activity instance
    if (activity.recurrentid && !activity.excludedFromRecurrent) {
      // Show dialog to choose between editing this or all future occurrences
      this.setState({ recurrentEditDialogOpen: true, recurrentEditError: null })
      return
    }

    // Normal save (non-recurrent or already excluded)
    this.performSave()
  }

  // Closes the editor if that is what was asked for and nothing else is waiting on the
  // user. Deliberately does nothing while a reservation dialog is up: those offer to move
  // or release court bookings, and closing over one would drop that decision silently.
  maybeClose = () => {
    if (!this.state.pendingClose) return
    if (this.state.driftDialogActivity || this.state.releaseDialogOpen) return
    this.setState({ pendingClose: false })
    if (this.props.onClose) this.props.onClose()
  }

  performSave = async () => {
    this.setState({ saving: true, saveError: null })
    // fix prices
    const { activity, priceInputs } = this.state
    const activityToSave = { ...activity }
    if (priceInputs.price) {
      // clear price
      let _price = priceInputs.price.replace(',', '.').replace(/[^0-9.]/g, '')
      activityToSave.price = parseFloat(_price)
    } else {
      activityToSave.price = 0
    }
    try {
      await this.props.firebase.updateActivity(activityToSave)
    } catch (error) {
      // The edits stay marked as edits, so Tallenna stays enabled for a retry.
      console.error('Error saving activity:', error)
      this.setState({
        saving: false,
        pendingClose: false,
        saveError: 'Tallennus epäonnistui, muutoksia ei tallennettu' + (error && error.message ? ': ' + error.message : '.'),
      })
      return
    }
    this.setState({ saving: false, edits: {}, activityEdits: {} })
    if (this.props.onUpdate) {
      this.props.onUpdate()
    }
    // The checks report whether they raised a dialog, rather than the caller reading state
    // straight after their setState and getting the stale value.
    const asked =
      this.checkReservationDrift(activityToSave) || this.checkReservationRelease(activityToSave)
    if (this.state.pendingClose && !asked) {
      this.setState({ pendingClose: false })
      if (this.props.onClose) this.props.onClose()
    }
  }

  // An activity whose time moved leaves its court bookings behind. Offer to move them
  // rather than rewriting someone's booking silently.
  // Returns true when it put a question to the user, so performSave knows not to close.
  checkReservationDrift = (activity) => {
    if (!this.isReservationsEnabled()) return false
    const drifted = driftedReservations(activity, activity.reservations)
    if (drifted.length === 0) return false
    this.setState({ driftDialogActivity: activity, driftedList: drifted })
    return true
  }

  closeDriftDialog = () =>
    this.setState({ driftDialogActivity: null, driftedList: [] }, this.maybeClose)

  moveDriftedReservations = async () => {
    const activity = this.state.driftDialogActivity
    if (!activity) return
    this.setState({ movingReservations: true })
    const moved = []
    for (let i = 0; i < this.state.driftedList.length; i++) {
      const reservation = this.state.driftedList[i]
      const result = await this.props.firebase.moveActivityReservation(
        reservation.id,
        activity.start,
        activity.end
      )
      if (!result || !result.error) moved.push(reservation.id)
    }
    const start = moment.utc(activity.start).format('YYYY-MM-DDTHH:mm:ssZ')
    const end = moment.utc(activity.end).format('YYYY-MM-DDTHH:mm:ssZ')
    const reservations = (activity.reservations || []).map((r) =>
      moved.includes(r.id) ? { ...r, start, end } : r
    )
    await this.props.firebase.updateActivity({ ...activity, reservations })
    this.setState(
      {
        movingReservations: false,
        driftDialogActivity: null,
        driftedList: [],
        activity: { ...this.state.activity, reservations },
      },
      this.maybeClose
    )
    if (this.props.onUpdate) this.props.onUpdate()
  }

  // Cancelling an activity should not silently keep its courts blocked, nor silently
  // free them -- ask.
  checkReservationRelease = (activity) => {
    if (!this.isReservationsEnabled()) return false
    if (activity.state !== 'cancelled') return false
    if (createdReservations(activity.reservations).length === 0) return false
    this.setState({ releaseDialogOpen: true })
    return true
  }

  closeReleaseDialog = () => this.setState({ releaseDialogOpen: false }, this.maybeClose)

  releaseReservations = async () => {
    const activity = this.state.activity
    const releasable = createdReservations(activity.reservations)
    this.setState({ releasing: true })
    const released = []
    for (let i = 0; i < releasable.length; i++) {
      const result = await this.props.firebase.cancelActivityReservation(releasable[i].id)
      if (!result || !result.error) released.push(releasable[i].id)
    }
    const reservations = (activity.reservations || []).filter((r) => !released.includes(r.id))
    await this.props.firebase.updateActivity({ ...activity, reservations })
    this.setState(
      {
        releasing: false,
        releaseDialogOpen: false,
        activity: { ...this.state.activity, reservations },
      },
      this.maybeClose
    )
    if (this.props.onUpdate) this.props.onUpdate()
  }

  handleRecurrentEditConfirm = async (editScope) => {
    this.setState({ recurrentEditLoading: true, recurrentEditError: null })

    const { activity, priceInputs } = this.state

    // Work on a copy to avoid mutating state
    // The recurrent path posts `changes` straight to the callables, bypassing
    // updateActivity, so extrainfo ids have to be assigned here.
    const activityCopy = this.props.firebase.resolveActivityExtraInfo({ ...activity })

    // fix prices
    if (priceInputs.price) {
      let _price = priceInputs.price.replace(',', '.').replace(/[^0-9.]/g, '')
      activityCopy.price = parseFloat(_price)
    } else {
      activityCopy.price = 0
    }

    // Prepare changes object (exclude participants, queue, payments, etc.)
    const changes = { ...activityCopy }
    delete changes.participants
    delete changes.queue
    delete changes.payments
    delete changes.refunds
    delete changes.id
    // Reservations belong to one occurrence. Sending them here would point every
    // future occurrence in the series at the same court booking.
    delete changes.reservations

    // "This and all future" with an edited time of day (or entry/cancellation time): the client
    // applies it to each occurrence on its own date (utils/recurrentTiming), so the absolute
    // dates are kept out of what the callable copies to every occurrence.
    const fromStart = this.originalStart || activity.start
    const timingEdited = editScope === 'future' && TIMING_FIELDS.some((field) => this.state.activityEdits[field])
    if (timingEdited) TIMING_FIELDS.forEach((field) => delete changes[field])

    try {
      let timingFailures = []
      if (editScope === 'this') {
        // Update only this occurrence and mark as excluded
        throwOnCallableError(await this.props.firebase.updateSingleRecurrentActivity(activity.id, changes))
      } else {
        // Update all future occurrences including this one
        throwOnCallableError(
          await this.props.firebase.updateFutureRecurrentActivities(
            activity.recurrentid,
            activity.id,
            changes,
            fromStart
          )
        )
        if (timingEdited) timingFailures = await this.applyFutureTiming(activityCopy, fromStart, this.state.activityEdits)
      }
      this.originalStart = activity.start
      this.setState({
        recurrentNotice: timingFailures.length
          ? 'Ajan muutos jäi tekemättä näille kerroille: ' + timingFailures.join(', ')
          : null,
      })

      // This path posts straight to the callables and never runs the drift/release checks,
      // so there is nothing that could be waiting on the user - it can close directly.
      this.setState(
        {
          recurrentEditDialogOpen: false,
          recurrentEditLoading: false,
          saving: false,
          edits: {},
          activityEdits: {}
        },
        this.maybeClose
      )

      if (this.props.onUpdate) {
        this.props.onUpdate()
      }
    } catch (error) {
      // The dialog stays open with the edits intact, so the save can be retried.
      console.error('Error saving recurrent activity:', error)
      this.setState({
        recurrentEditLoading: false,
        recurrentEditError: 'Tallennus epäonnistui, muutoksia ei tallennettu' + (error && error.message ? ': ' + error.message : '.'),
        saving: false
      })
    }
  }

  // The edited occurrence's times on every later occurrence of the series (each keeps its own
  // date), then on the series doc for occurrences generated later. Occurrences edited on their
  // own ("Vain tätä") keep their times, as the callable leaves them too. Returns the dates that
  // could not be updated.
  applyFutureTiming = async (edited, fromStart, edits) => {
    const timing = timingFromEdited(edited, { originalStart: fromStart, edits })
    if (!timing) return []
    const { firebase } = this.props
    const occurrences = await firebase.getRecurrentOccurrences(edited.recurrentid)
    const targets = futureOccurrences(occurrences, fromStart).filter((o) => o.id === edited.id || !o.excludedFromRecurrent)
    const failures = []
    for (const occurrence of targets) {
      try {
        await firebase.updateActivity(applyTiming(occurrence, timing))
      } catch (error) {
        console.error('Moving an occurrence failed', occurrence.id, error)
        failures.push(moment.utc(occurrence.start).format('D.M.'))
      }
    }
    try {
      await firebase.updateRecurrentActivity(edited.recurrentid, templateTiming(timing))
    } catch (error) {
      console.error('Updating the series times failed', error)
      failures.push('sarjan pohja')
    }
    return failures
  }

  handleRecurrentEditClose = () => {
    // Backing out of the scope question abandons the save, so the pending close goes with
    // it - otherwise it would fire off some later dialog the user did not connect to it.
    this.setState({ recurrentEditDialogOpen: false, pendingClose: false })
  }

  searchParticipants = (input) => {
    algoliaindex.search(input, { filters: '_tags:' + this.props.firebase.customerid }).then(({ hits }) => {
      const searchresults = hits
        .filter((x) => x.email && x.email.indexOf('_reg') < 0 && x.email.indexOf('_del') < 0)
        .map((x) => clearAlgolia(x))
      this.setState({ searchresults })
    })
  }

  // Rendered from both the participants tab and the queue tab - they are separate render
  // methods and only the active one is mounted, so the dialog has to appear in each.
  renderRemoveDialog = () => (
    <ActivityRemoveDialog
      open={!!this.state.removeTarget}
      target={this.state.removeTarget}
      activity={this.state.activity}
      removing={this.state.removing}
      error={this.state.removeError}
      onClose={this.closeRemoveDialog}
      onConfirm={this.confirmRemove}
    />
  )

  // Both removals go through one confirmation dialog, which also collects the refund
  // decision. kind picks which callable runs and how the dialog words itself.
  askRemove = (person, kind) => {
    this.setState({ removeTarget: { person, kind }, removeError: null })
  }

  closeRemoveDialog = () => {
    if (this.state.removing) return
    this.setState({ removeTarget: null, removeError: null })
  }

  confirmRemove = async (refund) => {
    const target = this.state.removeTarget
    if (!target || !target.person) return
    const activityid = this.props.activity.id
    const userid = target.person.id
    this.setState({ removing: true, removeError: null })
    const response =
      target.kind === 'queued'
        ? await this.props.firebase.removeQueuedFromActivity(activityid, [userid], refund)
        : await this.props.firebase.removeParticipantsFromActivity(activityid, [userid], refund)
    // Both resolve with { error } rather than throwing, so without this check the dialog
    // would close as if the removal had worked.
    if (response && response.error) {
      this.setState({ removing: false, removeError: response.error })
      return
    }
    this.setState({ removing: false, removeTarget: null })
    this.props.onUpdate()
  }

  movePtoQ = async (userid) => {
    let activityid = this.props.activity.id
    this.setState({ moving: true })
    await this.props.firebase.moveParticipantToQueue(activityid, userid)
    this.setState({ moving: false })
    this.props.onUpdate()
  }

  moveQtoP = async (userid) => {
    let activityid = this.props.activity.id
    this.setState({ moving: true })
    await this.props.firebase.moveParticipantFromQueue(activityid, userid)
    this.setState({ moving: false })
    this.props.onUpdate()
  }

  checkinoutParticipant = async (userid) => {
    let activityid = this.props.activity.id
    this.setState({ checkin: { [userid]: true } })
    await this.props.firebase.checkinoutParticipant(activityid, userid, 'in')
    this.props.onUpdate()
  }

  openPaymentDialog = (participant) => {
    this.setState({ paymentParticipant: participant })
  }

  closePaymentDialog = () => {
    this.setState({ paymentParticipant: null })
  }

  // The payment lands on the activity document, so the whole activity has to come back
  // before the Maksettu and Maksutapa columns can show it.
  handlePaymentSaved = () => {
    this.props.onUpdate()
  }

  // Answers live on participants[].extrainfo / queue[].extrainfo as { questionId: answer },
  // written by the backend at enrolment.
  //
  // A column each reads best, but an activity with several questions pushed the grid
  // far wider than its box. Past a couple of questions they collapse into one column
  // holding "Kysymys: vastaus" pairs, so the grid width no longer grows with the number
  // of questions. The combined text is produced by valueGetter, which is also what the
  // CSV export reads, so exporting still yields every answer.
  getExtraInfoColumns = () => {
    const extrainfo = ((this.state.activity && this.state.activity.extrainfo) || []).filter(
      (question) => question && question.id
    )
    if (extrainfo.length === 0) return []

    if (extrainfo.length <= EXTRAINFO_COLUMN_LIMIT) {
      return extrainfo.map((question) => ({
        field: 'extrainfo_' + question.id,
        headerName: question.title || 'Lisätieto',
        width: 160,
        disableClickEventBubbling: true,
        valueGetter: (value, row) => (row && row.extrainfo && row.extrainfo[question.id]) || '',
      }))
    }

    return [
      {
        field: 'extrainfo_all',
        headerName: 'Lisätiedot',
        width: 320,
        sortable: false,
        filterable: false,
        disableClickEventBubbling: true,
        valueGetter: (value, row) =>
          extrainfo
            .map((question) => {
              const answer = row && row.extrainfo ? row.extrainfo[question.id] : ''
              return answer ? (question.title || 'Lisätieto') + ': ' + answer : null
            })
            .filter(Boolean)
            .join(SEPARATOR),
        renderCell: (params) => {
          const parts = String(params.value || '').split(SEPARATOR).filter(Boolean)
          return (
            <Tooltip
              title={
                <span>
                  {parts.map((part, index) => (
                    <div key={index}>{part}</div>
                  ))}
                </span>
              }
            >
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {params.value}
              </span>
            </Tooltip>
          )
        },
      },
    ]
  }

  // Shown above the participants: until when people can enrol and cancel.
  renderParticipationDeadlines = () => {
    const a = this.state.activity
    if (!a || !a.entryend) return null
    const format = (value) => moment(value).format('D.M.YY HH:mm')
    return (
      <Typography variant='body2' color='textSecondary' sx={{ mb: 1 }}>
        Ilmoittautuminen päättyy {format(a.entryend)} · Peruutus päättyy {format(effectiveCancellationEnd(a))}
        {hasOwnCancellationEnd(a) ? '' : ' (sama kuin ilmoittautuminen)'}
      </Typography>
    )
  }

  // Participant / queue name, linking to the person's page (utils/links). The value stays
  // plain text, so the CSV export is unchanged.
  personNameColumn = () => ({
    field: 'name',
    headerName: 'Name',
    disableClickEventBubbling: true,
    width: 200,
    renderCell: (params) => {
      const to = personPath(params.row.id)
      if (!to) return params.value
      return (
        <RouterLink to={to} title='Avaa henkilön tiedot'>
          {params.value}
        </RouterLink>
      )
    },
  })

  renderActivityParticipants = () => {
    const { participants, payments } = this.state.activity
    if (!participants) return null
    const columns = [
      {
        field: 'initials',
        headerName: '',
        disableClickEventBubbling: true,
        width: 30,
        renderCell: (params) => (
          <IconButton
            style={{ padding: 0 }}
            disabled={params.row.checkin ? true : false}
            onClick={() => this.checkinoutParticipant(params.row.id)}
          >
            <Avatar style={{ backgroundColor: params.row.checkin ? 'green' : 'gray' }}>
              {this.state.checkin[params.row.id] ? <CircularProgress size={10} /> : params.value}
            </Avatar>
          </IconButton>
        ),
      },
      this.personNameColumn(),
      { field: 'email', headerName: 'Email', disableClickEventBubbling: true, width: 200 },
      {
        field: 'entry',
        headerName: 'Ilmoittautunut',
        width: 150,
        disableClickEventBubbling: true,
        valueFormatter: (value) => moment(value).format('DD.MM.YYYY HH:mm'),
      },
      {
        field: 'paymenttime',
        headerName: 'Maksettu',
        width: 150,
        disableClickEventBubbling: true,
        valueFormatter: (value) =>
          moment(value).isValid() ? moment(value).format('DD.MM.YYYY HH:mm') : '',
      },
      {
        field: 'paymenttype',
        headerName: 'Maksutapa',
        width: 150,
        disableClickEventBubbling: true,
      },
      {
        field: 'note',
        headerName: 'Lisätieto',
        width: 250,
        disableClickEventBubbling: true,
      },
      // One column per configured extra-info question. 'note' above stays: it carries the
      // legacy single free-text field enabled by the activityextrafields config flag.
      ...this.getExtraInfoColumns(),
      {
        field: 'checkinout',
        headerName: ' ',
        width: 100,
        disableClickEventBubbling: true,
        renderCell: (params) => (
          <CheckInoutButton
            disabled={params.row.checkin ? true : false}
            loading={this.state.checkin[params.row.id]}
            onClick={() => this.checkinoutParticipant(params.row.id)}
          />
        ),
      },
      {
        field: 'addpayment',
        headerName: ' ',
        width: 130,
        disableClickEventBubbling: true,
        sortable: false,
        filterable: false,
        // Not disabled once paid: part payments are a real case, and the dialog shows any
        // existing payment so the manager is not adding a duplicate blind.
        renderCell: (params) => <AddPaymentButton onClick={() => this.openPaymentDialog(params.row)} />,
      },
      {
        field: 'mov',
        headerName: ' ',
        width: 100,
        disableClickEventBubbling: true,
        renderCell: (params) => <MoveButton onClick={() => this.movePtoQ(params.row.id)} />,
      },
      {
        field: 'del',
        headerName: ' ',
        width: 100,
        disableClickEventBubbling: true,
        renderCell: (params) => <DeleteButton onClick={() => this.askRemove(params.row, 'participant')} />,
      },
    ]
    const _ps = participants.map((participant, index) => {
      participant.rowkey = (index + 1) + '-' + participant.id
      const initials =
        (participant.firstname ? participant.firstname.charAt(0) : '') +
        '' +
        (participant.lastname ? participant.lastname.charAt(0) : '')
      const name = participant.firstname + ' ' + participant.lastname
      participant.initials = initials
      participant.name = name
      if (payments && payments.length > 0) {
        const payment = payments.find((x) => x.uid === participant.id)
        if (payment) {
          participant.paymenttime = payment.timestamp
          participant.paymenttype = payment.typelabel || ''
        } else {
          participant.paymenttime = ''
          participant.paymenttype = ''
        }
      } else {
        participant.paymenttime = ''
        participant.paymenttype = ''
      }
      return participant
    })
    console.log('_ps', _ps)
    return (
      <React.Fragment>
        <div style={{ display: 'flex', minHeight: 'calc(100vh - 400px)', backgroundColor: '#FFFFFF' }}>
          <div style={{ flexGrow: 1, minWidth: 0 }}>
            {/* DataGrid is v8: components/componentsProps were renamed slots/slotProps in v6
                and removed in v7, and v8 also hides the toolbar unless showToolbar is set -
                so the export button silently disappeared. pageSize went the same way and is
                now initialState + pageSizeOptions. */}
            <DataGrid
              rows={_ps}
              getRowId={(row) => row.rowkey}
              columns={columns}
              initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
              pageSizeOptions={[20, 50, 100]}
              showToolbar
              slots={{ toolbar: ExportToolbar }}
              slotProps={{
                toolbar: {
                  suffix: 'participants',
                  name: this.state.activity.name.fi,
                  date: this.state.activity.start,
                },
              }}
            />
          </div>
        </div>
        <ActivityPaymentDialog
          open={!!this.state.paymentParticipant}
          onClose={this.closePaymentDialog}
          onSaved={this.handlePaymentSaved}
          activity={this.state.activity}
          participant={this.state.paymentParticipant}
        />
        {this.renderRemoveDialog()}
      </React.Fragment>
    )
  }

  renderActivityQueue = () => {
    const { queue } = this.state.activity
    if (!queue) return null
    const columns = [
      {
        field: 'initials',
        headerName: '',
        disableClickEventBubbling: true,
        width: 30,
        renderCell: (params) => <Avatar>{params.value}</Avatar>,
      },
      this.personNameColumn(),
      { field: 'email', headerName: 'Email', disableClickEventBubbling: true, width: 200 },
      {
        field: 'entry',
        headerName: 'Ilmoittautunut',
        width: 150,
        disableClickEventBubbling: true,
        valueFormatter: (value) => moment(value).format('DD.MM.YYYY HH:mm'),
      },
      // Same columns as the participants list. A queued person can have paid - the removal
      // dialog already accounts for it - so the payment columns are as relevant here.
      {
        field: 'paymenttime',
        headerName: 'Maksettu',
        width: 150,
        disableClickEventBubbling: true,
        valueFormatter: (value) =>
          moment(value).isValid() ? moment(value).format('DD.MM.YYYY HH:mm') : '',
      },
      {
        field: 'paymenttype',
        headerName: 'Maksutapa',
        width: 150,
        disableClickEventBubbling: true,
      },
      {
        field: 'checkin',
        headerName: 'Kirjattu sisään',
        width: 150,
        disableClickEventBubbling: true,
        valueFormatter: (value) =>
          value && moment(value).isValid() ? moment(value).format('DD.MM.YYYY HH:mm') : '',
      },
      {
        field: 'note',
        headerName: 'Lisätieto',
        width: 250,
        disableClickEventBubbling: true,
      },
      // One column per configured extra-info question. 'note' above stays: it carries the
      // legacy single free-text field enabled by the activityextrafields config flag.
      ...this.getExtraInfoColumns(),
      {
        field: 'addpayment',
        headerName: ' ',
        width: 130,
        disableClickEventBubbling: true,
        sortable: false,
        filterable: false,
        renderCell: (params) => <AddPaymentButton onClick={() => this.openPaymentDialog(params.row)} />,
      },
      {
        field: 'mov',
        headerName: ' ',
        width: 100,
        disableClickEventBubbling: true,
        renderCell: (params) => <MoveButton onClick={() => this.moveQtoP(params.row.id)} />,
      },
      {
        field: 'del',
        headerName: ' ',
        width: 100,
        disableClickEventBubbling: true,
        renderCell: (params) => <DeleteButton onClick={() => this.askRemove(params.row, 'queued')} />,
      },
    ]
    const payments = this.state.activity.payments
    const _ps = queue.map((participant, index) => {
      participant.rowkey = (index + 1) + '-' + participant.id
      const initials =
        (participant.firstname ? participant.firstname.charAt(0) : '') +
        '' +
        (participant.lastname ? participant.lastname.charAt(0) : '')
      const name = participant.firstname + ' ' + participant.lastname
      participant.initials = initials
      participant.name = name
      // payments[] hangs off the activity and is matched by uid, exactly as in the
      // participants list.
      const payment = payments && payments.length > 0 ? payments.find((x) => x.uid === participant.id) : null
      participant.paymenttime = payment ? payment.timestamp : ''
      participant.paymenttype = payment ? payment.typelabel || '' : ''
      return participant
    })
    return (
      <React.Fragment>
        <div style={{ display: 'flex', minHeight: 'calc(100vh - 400px)', backgroundColor: '#FFFFFF' }}>
          <div style={{ flexGrow: 1, minWidth: 0 }}>
            <DataGrid
              rows={_ps}
              getRowId={(row) => row.rowkey}
              columns={columns}
              initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
              pageSizeOptions={[20, 50, 100]}
              showToolbar
              slots={{ toolbar: ExportToolbar }}
              slotProps={{
                toolbar: {
                  suffix: 'queue',
                  name: this.state.activity.name.fi,
                  date: this.state.activity.start,
                },
              }}
            />
          </div>
        </div>
        <ActivityPaymentDialog
          open={!!this.state.paymentParticipant}
          onClose={this.closePaymentDialog}
          onSaved={this.handlePaymentSaved}
          activity={this.state.activity}
          participant={this.state.paymentParticipant}
        />
        {this.renderRemoveDialog()}
      </React.Fragment>
    )
  }

  handlePersonSearch = (event, value) => {
    const { activity } = this.state
    if (!activity.organisers) {
      activity.organisers = []
    }
    if (value) {
      activity.organisers = value.map((x) => {
        return { id: x.id, firstname: x.firstname, lastname: x.lastname, email: x.email, phone: x.phone || '' }
      })
      console.log(activity.organisers)
    }
    this.setState({ activity, activityEdits: { ...this.state.activityEdits, 'organisers': true } })
  }

  // The price being edited right now, so a percentage row previews against the value
  // on screen rather than the one last saved.
  getEditedPrice = () => {
    const raw = this.state.priceInputs.price
    if (raw !== undefined && raw !== null && raw !== '') {
      const parsed = parseFloat(String(raw).replace(',', '.').replace(/[^0-9.]/g, ''))
      if (isFinite(parsed)) return parsed
    }
    return this.state.activity.price || 0
  }

  // Rendered at BOTH ends of the Yleistiedot form, which is long enough that scrolling to
  // the bottom to save is a chore. Same buttons, same state - not a second save path.
  renderSaveButtons = () => {
    const isEdited = Object.values(this.state.activityEdits).some((value) => value)
    const invalid = !!cancellationEndError(this.state.activity)
    return (
      <Row>
        <Col xs={12} className='text-right'>
          {/* The spinner shows on whichever button was pressed, so it is obvious which
              save is running. pendingClose tells them apart. */}
          <Button
            disabled={!isEdited || invalid || this.state.saving}
            color='success'
            outline
            onClick={() => this.handleSave(false)}
          >
            {this.state.saving && !this.state.pendingClose ? <Spinner size={'sm'} /> : 'Tallenna'}
          </Button>{' '}
          <Button
            disabled={!isEdited || invalid || this.state.saving}
            color='success'
            onClick={() => this.handleSave(true)}
          >
            {this.state.saving && this.state.pendingClose ? <Spinner size={'sm'} /> : 'Tallenna ja sulje'}
          </Button>
          {this.state.saveError ? (
            <Typography variant='caption' color='error' display='block'>
              {this.state.saveError}
            </Typography>
          ) : null}
          {this.state.recurrentNotice ? (
            <Typography variant='caption' color='error' display='block'>
              {this.state.recurrentNotice}
            </Typography>
          ) : null}
        </Col>
      </Row>
    )
  }

  // "Tallenna pohjaksi": an activity template from this activity, its dates turned into
  // times relative to the start (docs/features/activity-templates.md). External activities
  // and occurrences of a series are left out: the first has no own content to reuse, the
  // second has its recurring template already.
  canSaveAsTemplate = () => {
    const a = this.props.activity
    return !!(a && a.id && !a.isexternal && !a.recurrentid)
  }

  openTemplateDraft = () => {
    this.setState({ templateDraft: templateFromActivity(this.state.activity), templateSaved: false })
  }

  renderTemplateDraft = () => (
    <div style={{ padding: 20, backgroundColor: 'white' }}>
      <Row className='mb-2'>
        <Col>
          <Typography variant='h5' gutterBottom>
            Tallenna pohjaksi: {this.state.activity.name && this.state.activity.name.fi}
          </Typography>
          <Typography variant='body2' color='textSecondary'>
            Päivämäärät muuttuvat ajoiksi suhteessa alkuun. Pohja löytyy kohdasta Aktiviteetit &gt; Pohjat ja
            aktiviteettikalenterin vierestä.
          </Typography>
          <Button className='mt-2' size='sm' onClick={() => this.setState({ templateDraft: null })}>
            Takaisin aktiviteettiin
          </Button>
        </Col>
      </Row>
      <ActivityCreator
        template
        initialActivity={this.state.templateDraft}
        onCreate={this.props.firebase.createActivityTemplate}
        onSaved={() => this.setState({ templateDraft: null, templateSaved: true })}
        activitytypes={this.state.activitytypes}
        sports={this.state.sports}
        images={this.props.images}
        customerdata={this.props.customerdata}
      />
    </div>
  )

  // Read-only recap of what each membership actually pays.
  renderMembershipPricesSummary = (membershipPrices) => {
    if (!membershipPrices || membershipPrices.length === 0) return null
    const activityPrice = this.getEditedPrice()
    const parts = membershipPrices
      .filter((row) => row.membership)
      .map((row) => {
        const membership = this.state.memberships.find((m) => m.id === row.membership)
        const name = membership ? membershipLabel(membership) : row.membership
        const effective = effectiveMembershipPrice(row, activityPrice)
        const amount = effective === null ? '-' : effective.toFixed(2).replace('.', ',') + ' €'
        const suffix = rowPriceType(row) === PRICETYPE_DISCOUNT ? ' (-' + (row.discount || 0) + ' %)' : ''
        return name + ' ' + amount + suffix
      })
    if (parts.length === 0) return null
    return (
      <Typography variant='body2' color='textSecondary' style={{ marginTop: 4 }}>
        Jäsenhinnat: {parts.join(' · ')}
      </Typography>
    )
  }

  renderActivityGeneralData = () => {
    const {
      nameEditOpen,
      startEditOpen,
      endEditOpen,
      priceEditOpen,
      typeEditOpen,
      sportEditOpen,
      skillLevelEditOpen,
      genderEditOpen,
      ingressEditOpen,
      descEditOpen,
      minpEditOpen,
      entrystartEditOpen,
      maxpEditOpen,
      entryendEditOpen,
      cancellationendEditOpen,
      stateEditOpen,
      posterEditOpen,
    } = this.state.edits
    const {
      id,
      description,
      ingress,
      // poster,
      start,
      end,
      entrystart,
      entryend,
      maxp,
      minp,
      state,
      hasqueue,
      price,
      type,
      sport,
      skillLevel,
      gender,
      name,
      media,
      showusers,
      hideentrycount,
      pinned,
      membershipPrices,
      extrainfo,

    } = this.state.activity
    // console.log('state', state)
    return (
      <>
        {this.renderSaveButtons()}
        <Row id={id}>
          <Col xs={3}>Nimi</Col>
          <Col xs={3}>
            {nameEditOpen ? (
              <TextField
                autoFocus
                id='name-local'
                value={name.fi || ''}
                onChange={(e) => this.handleTextChange(e, 'name.fi')}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            ) : (
              <div>
                {name.fi} <EditIconButton onClick={() => this.setEditState('nameEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row id={id}>
          <Col xs={3}>Aika</Col>
          <Col xs={9}>
            {startEditOpen || endEditOpen ? (
              <ActivityTimeRange start={start} end={end} onChange={this.handleTimeRangeChange} />
            ) : (
              <div>
                {moment(start).format('D.M.YY HH:mm')} - {moment(end).format(
                  moment(start).isSame(moment(end), 'day') ? 'HH:mm' : 'D.M.YY HH:mm'
                )}{' '}
                <EditIconButton onClick={() => this.setEditState('startEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Hinta</Col>
          <Col xs={3}>
            {priceEditOpen ? (
              <TextField
                autoFocus
                id='price-local'
                value={this.state.priceInputs.price || ''}
                onChange={(e) => this.handlePriceChange(e, 'price')}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            ) : (
              <div>
                {price} €
                <EditIconButton onClick={() => this.setEditState('priceEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Jäsenhinnat</Col>
          <Col xs={9}>
            <MembershipPricesEditor
              value={membershipPrices}
              memberships={this.state.memberships}
              activityPrice={this.getEditedPrice()}
              onChange={(value) => this.handleArrayChange(value, 'membershipPrices')}
            />
            {this.renderMembershipPricesSummary(membershipPrices)}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Lisätietokysymykset (kysytään asiakkaalta ilmoittautuessa)</Col>
          <Col xs={9}>
            <ExtraInfoQuestionsEditor
              value={extrainfo}
              onChange={(value) => this.handleArrayChange(value, 'extrainfo')}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Aktiviteetti tyyppi</Col>
          <Col xs={3}>
            {typeEditOpen ? (
              <TextField
                autoFocus
                id='standard-select-type'
                select
                required
                label='Tyyppi'
                value={type}
                helperText='Aktiviteetin tyyppi'
                onChange={(e) => this.handleTextChange(e, 'type')}
              >
                {this.state.activitytypes.map((option) => (
                  <MenuItem key={option.key} value={option.label}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            ) : (
              <div>
                {type}
                <EditIconButton onClick={() => this.setEditState('typeEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Laji</Col>
          <Col xs={3}>
            {sportEditOpen ? (
              <TextField
                autoFocus
                id='standard-select-sport'
                select
                required
                label='Laji'
                value={sport}
                helperText='Laji'
                onChange={(e) => this.handleTextChange(e, 'sport')}
              >
                {this.state.sports.map((option) => (
                  <MenuItem key={option.key} value={option.label}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            ) : (
              <div>
                {sport}
                <EditIconButton onClick={() => this.setEditState('sportEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Taso</Col>
          <Col xs={3}>
            {skillLevelEditOpen ? (
              <TextField
                autoFocus
                id='activity-skilllevel'
                label='Taso'
                value={skillLevel || ''}
                helperText='Vapaa teksti, esim. Alkeet tai ⭐⭐⭐'
                onChange={(e) => this.handleTextChange(e, 'skillLevel')}
              />
            ) : (
              <div>
                {skillLevel}
                <EditIconButton onClick={() => this.setEditState('skillLevelEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Sukupuoli</Col>
          <Col xs={3}>
            {genderEditOpen ? (
              <TextField
                autoFocus
                id='standard-select-gender'
                select
                required
                label='Sukupuoli'
                value={gender}
                helperText='Onko aktiviteetti vain miehille vai naisille vai kaikille'
                onChange={(e) => this.handleTextChange(e, 'gender')}
              >
                {GENDERS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            ) : (
              <div>
                {GENDERS.find((g) => g.value === gender)?.label || gender}
                <EditIconButton onClick={() => this.setEditState('genderEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Lyhyt kuvaus</Col>
          <Col xs={3}>
            {' '}
            {ingressEditOpen ? (
              <TextField
                autoFocus
                required
                multiline={true}
                fullWidth
                minRows={2}
                id='ingress-fi'
                label='Lyhyt kuvaus'
                size='small'
                value={ingress.fi}
                variant='outlined'
                onChange={(e) => this.handleTextChange(e, 'ingress.fi')}
              />
            ) : (
              <div>
                {ingress.fi}
                <EditIconButton onClick={() => this.setEditState('ingressEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Kuvaus</Col>
          <Col xs={3}>
            {descEditOpen ? (
              <TextField
                autoFocus
                required
                multiline={true}
                fullWidth
                minRows={5}
                id='desc-fi'
                label='Pitempi kuvaus'
                size='small'
                value={description.fi}
                variant='outlined'
                onChange={(e) => this.handleTextChange(e, 'description.fi')}
              />
            ) : (
              <div>
                {description.fi}
                <EditIconButton onClick={() => this.setEditState('descEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row id={id}>
          <Col xs={3}>Ilmoittautumisen alkuaika</Col>
          <Col xs={6}>
            {entrystartEditOpen ? (
              <DateTimeSelect
                label='Ilmoittautuminen alkaa'
                value={entrystart}
                onChange={(value) => this.handleValueChange(value, 'entrystart')}
              />
            ) : (
              <div>
                {moment(entrystart).format('D.M.YY HH:mm')}{' '}
                <EditIconButton onClick={() => this.setEditState('entrystartEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Ilmoittautumisen loppuaika</Col>
          <Col xs={6}>
            {entryendEditOpen ? (
              <DateTimeSelect
                label='Ilmoittautuminen päättyy'
                value={entryend}
                onChange={(value) => this.handleValueChange(value, 'entryend')}
              />
            ) : (
              <div>
                {moment(entryend).format('D.M.YY HH:mm')}{' '}
                <EditIconButton onClick={() => this.setEditState('entryendEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Peruutuksen takaraja</Col>
          <Col xs={6}>
            {cancellationendEditOpen ? (
              <div>
                <FormControlLabel
                  control={<Switch checked={hasOwnCancellationEnd(this.state.activity)} onChange={this.toggleCancellationEnd} />}
                  label='Erillinen peruutuksen takaraja'
                />
                {hasOwnCancellationEnd(this.state.activity) ? (
                  <DateTimeSelect
                    label='Peruutus päättyy'
                    value={this.state.activity.cancellationend}
                    onChange={(value) => this.handleValueChange(value, 'cancellationend')}
                  />
                ) : (
                  <Typography variant='caption' color='textSecondary' display='block'>
                    Pois päältä: osallistumisen voi perua niin kauan kuin ilmoittautuminen on auki.
                  </Typography>
                )}
              </div>
            ) : (
              <div>
                {hasOwnCancellationEnd(this.state.activity)
                  ? moment(this.state.activity.cancellationend).format('D.M.YY HH:mm')
                  : 'Sama kuin ilmoittautumisen päättyminen'}{' '}
                <EditIconButton onClick={() => this.setEditState('cancellationendEditOpen', true)} />
              </div>
            )}
            {cancellationEndError(this.state.activity) ? (
              <Typography variant='caption' color='error' display='block'>
                {cancellationEndError(this.state.activity)}
              </Typography>
            ) : null}
          </Col>
        </Row>

        <Row>
          <Col xs={3}>Minimi osallistujat</Col>
          <Col xs={3}>
            {minpEditOpen ? (
              <TextField
                autoFocus
                required
                id='minp-required'
                label='Minimimäärä'
                size='small'
                value={minp}
                onChangeCapture={(e) => this.handleNumberChange(e, 'minp')}
              />
            ) : (
              <div>
                {minp} <EditIconButton onClick={() => this.setEditState('minpEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>

        <Row>
          <Col xs={3}>Maksimi osallistujat</Col>
          <Col xs={3}>
            {maxpEditOpen ? (
              <TextField
                autoFocus
                required
                id='maxp-required'
                label='Maksimimäärä'
                size='small'
                value={maxp}
                onChangeCapture={(e) => this.handleNumberChange(e, 'maxp')}
              />
            ) : (
              <div>
                {maxp} <EditIconButton onClick={() => this.setEditState('maxpEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Kuva</Col>
          <Col xs={3}>
            {posterEditOpen ? (
              <div>
                <Spinner />
              {/* <TextField
                id='standard-select-poster'
                select
                required
                label='Poster'
                value={media?.id}
                helperText='Valitse kuvituskuva'
                onChange={(e) => this.handlePosterChange(e)}
              >
                {this.props.images.map((image) => (
                  <MenuItem key={image.id} value={image.id}>
                    <img src={image.url} alt={image.originalName} width='20px' height='20px' />
                    {image.originalName}
                  </MenuItem>
                ))}
                </TextField> */}
              </div>
            ) : (
              <div>
                {media?.id ? <img src={media?.url} alt={media?.originalName} /> : ''} {media?.originalName}
                <EditIconButton onClick={() => this.setEditState('posterEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Onko jonotus käytössä</Col>
          <Col xs={3}>
            <FormControlLabel
              control={<Switch checked={hasqueue} onChange={(e) => this.handleSwitchChange(e, 'hasqueue')} />}
              label='Jono käytössä'
            />
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Automaattinen peruutus</Col>
          <Col xs={3}>
            <FormControlLabel
              control={<Switch checked={this.state.activity.autoCancellation} onChange={(e) => this.handleSwitchChange(e, 'autoCancellation')} />}
              label='Automaattinen peruutus käytössä'
            />
            <Typography variant='caption' color='textSecondary' display='block'>
              Tapahtuma perutaan automaattisesti ilmoittautumisen päätyttyä, jos vähimmäisosallistujamäärä ei täyty.
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Tila</Col>
          <Col xs={3}>
            {stateEditOpen ? (
              <TextField
                autoFocus
                id='standard-select-state'
                select
                required
                label='Tila'
                value={state}
                helperText=''
                onChange={(e) => this.handleTextChange(e, 'state')}
              >
                {STATES.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            ) : (
              <div>
                {STATES.find((s) => s.value === state)?.label || state}
                <EditIconButton onClick={() => this.setEditState('stateEditOpen', true)} />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Ohjaaja(t)</Col>
          <Col xs={3}>
            <PersonSearch onChange={this.handlePersonSearch} values={this.state?.activity?.organisers || null} />
          </Col>
        </Row>
        {this.hasOrganisers() ? (
          <Row>
            <Col xs={3}>Ilmoitus ohjaajalle osallistujamuutoksista</Col>
            <Col xs={3}>
              <TextField
                id='standard-select-organisernotification'
                select
                size='small'
                value={getOrganiserNotification(this.state.activity)}
                onChange={(e) => this.handleTextChange(e, 'organiserNotification')}
              >
                {ORGANISER_NOTIFICATION_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Col>
          </Row>
        ) : null}
        <Row>
          <Col xs={3}>Näytetäänkö ilmoittautuneiden nimet</Col>
          <Col xs={3}>
            <FormControlLabel
              control={<Switch checked={showusers} onChange={(e) => this.handleSwitchChange(e, 'showusers')} />}
              label='Näytä ilmoittautuneiden nimet'
            />
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Piilotetaanko ilmoittautuneiden määrät</Col>
          <Col xs={3}>
            <FormControlLabel
              control={<Switch checked={hideentrycount} onChange={(e) => this.handleSwitchChange(e, 'hideentrycount')} />}
              label='Piilota ilmoittautuneiden määrät'
            />
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Nostetaanko tapahtumaa</Col>
          <Col xs={3}>
            <FormControlLabel
              control={<Switch checked={pinned} onChange={(e) => this.handleSwitchChange(e, 'pinned')} />}
              label='Nosta tapahtuma ylimmäksi asiakasnäkymässä'
            />
          </Col>
        </Row>
        <Row>
        <Col xs={3}>Sisäinen tapahtumaluokka</Col>
          <Col xs='3'>
            <TextField
              id='providertype'
              label=''
              size='small'
              onChange={(e) => this.handleTextChange(e, 'providertype')}
              value={this.state.activity.providertype}
            />
          </Col>
        </Row>
        <Row>
        <Col xs={3}>Alv %</Col>
          <Col xs={3}>
            <TextField
              id='standard-select-vat'
              select
              required
              label='Alv%'
              value={this.state.activity.vat}
              helperText='Alv prosentti'
              onChange={(e) => this.handleNumberChange(e, 'vat')}
            >
              {[0, 10, 13.5, 14, 24, 25.5].map((option) => (
                <MenuItem key={option} value={option} disabled={DISABLED_VAT_OPTIONS.includes(option)}>
                  {option} %
                </MenuItem>
              ))}
            </TextField>
          </Col>
        </Row>
        <Row>
        <Col xs={3}>Tuotekoodi</Col>
          <Col xs={3}>
            <TextField
              fullWidth
              id='productCode'
              label='Tuotekoodi'
              size='small'
              onChange={(e) => this.handleTextChange(e, 'productCode')}
              value={this.state.activity.productCode}
            />
          </Col>
        </Row>
        <Row>
        <Col xs={3}>Kirjanpidon tili</Col>
          <Col xs={3} >
            <TextField
              fullWidth
              id='accounting'
              label='Kirjanpitotili'
              size='small'
              onChange={(e) => this.handleTextChange(e, 'accounting')}
              value={this.state.activity.accounting}
            />
          </Col>
        </Row>

        {this.state.pin ? (
          <Row>
            <Col xs={3}>PIN</Col>
            <Col xs={3}>{this.state.pin}</Col>
          </Row>
        ) : null}

        {this.renderSaveButtons()}
      </>
    )
  }

  toggleNav = (tab) => {
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab })
  }

  removeCustomershipFromPerson = async () => {
    await this.props.firebase.removeCustomership(this.props.person.id)
    this.toggleRemoveDialog()
  }

  renderAddSaldoRow = () => {
    return (
      <React.Fragment>
        <Row style={{ marginTop: 20 }}>
          {this.state.venues.length > 0 ? (
            <Col md='3'>
              <FormControl style={{ width: '100%' }}>
                <InputLabel id='venue'>Paikka</InputLabel>
                <Select
                  fullWidth
                  labelId='venue-label'
                  id='venue'
                  value={this.state.saldovenue || ''}
                  onChange={this.handleSaldoVenue}
                >
                  {this.state.venues.map((v, i) => {
                    return (
                      <MenuItem key={'venue' + i} value={v.toLowerCase()}>
                        {v}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Col>
          ) : null}
          <Col md='3'>
            <FormControl style={{ width: '100%' }}>
              <InputLabel id='saldotype'>Saldo</InputLabel>
              <Select
                labelId='saldotype-label'
                id='saldotype'
                value={this.state.saldowallet || ''}
                onChange={this.handleSaldoWallet}
              >
                <MenuItem value={'cash'}>Käteinen</MenuItem>
                {/* <MenuItem value={'sportmoney'}>Liikuntaraha</MenuItem> */}
              </Select>
            </FormControl>
          </Col>
          <Col md='3'>
            <FormControl style={{ width: '100%' }}>
              <InputLabel id='paymenttype'>Tapahtuma</InputLabel>
              <Select
                fullWidth
                labelId='paymenttype-label'
                id='paymenttype'
                value={this.state.saldotype || ''}
                onChange={this.handleSaldoType}
              >
                <MenuItem key={'none'}></MenuItem>
                {paymenttypes.map((pt) => {
                  return (
                    <MenuItem key={pt.value} value={pt.value}>
                      {pt.label}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Col>
          <Col md='2'>
            <TextField
              id='paymentamount'
              label='Summa'
              type='text'
              value={this.state.saldoamount || ''}
              InputProps={{
                endAdornment: <InputAdornment position='end'>€</InputAdornment>,
              }}
              onChange={this.handleSaldoAmount}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 20 }}>
          <Col md='8'>
            <TextField
              fullWidth
              id='saldodescription'
              label='Kuvaus'
              type='text'
              value={this.state.saldodescription || ''}
              onChange={this.handleSaldoDescription}
            />
          </Col>
          <Col md='4'>
            <Button
              outline
              size='sm'
              color='success'
              disabled={!(this.state.saldowallet && this.state.saldoamount && this.state.saldotype)}
              onClick={this.onSaveSaldoPayment}
            >
              {this.state.savingsaldo ? <Spinner size='sm' /> : 'Lisää'}
            </Button>
            <Button outline color='primary' size='sm' onClick={this.toggleAddSaldo}>
              Peruuta
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    )
  }

  renderAddSaldoButton = () => {
    return (
      <Row style={{ marginTop: 5, marginBottom: 10 }}>
        <Col>
          <AddCircleIcon fontSize='small' onClick={this.toggleAddSaldo} /> Lisää saldoa
        </Col>
      </Row>
    )
  }

  renderAddStorageRow = () => {
    return (
      <React.Fragment>
        <Row style={{ marginTop: 20 }}>
          {this.state.venues.length > 0 ? (
            <Col md='3'>
              <FormControl style={{ width: '100%' }}>
                <InputLabel id='venue'>Paikka</InputLabel>
                <Select
                  fullWidth
                  labelId='venue-label'
                  id='venue'
                  value={this.state.storagevenue || ''}
                  onChange={this.handleStorageVenue}
                >
                  {this.state.venues.map((v, i) => {
                    return (
                      <MenuItem key={'venue' + i} value={v.toLowerCase()}>
                        {v}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Col>
          ) : null}
          <Col md='3'>
            <FormControl style={{ width: '100%' }}>
              <InputLabel id='saldotype'>Pankki/Varasto</InputLabel>
              <Select
                labelId='saldotype-label'
                id='saldotype'
                value={this.state.storagewallet || ''}
                onChange={this.handleStorageWallet}
              >
                <MenuItem value={'cash'}>Käteinen</MenuItem>
                <MenuItem value={'minutes'}>Aika</MenuItem>
              </Select>
            </FormControl>
          </Col>
          <Col md='3'>
            <FormControl style={{ width: '100%' }}>
              <InputLabel id='paymenttype'>Tapahtuma</InputLabel>
              <Select
                fullWidth
                labelId='paymenttype-label'
                id='paymenttype'
                value={this.state.storagetype || ''}
                onChange={this.handleStorageType}
              >
                <MenuItem key={'none'}></MenuItem>
                {paymenttypes.map((pt) => {
                  return (
                    <MenuItem key={pt.value} value={pt.value}>
                      {pt.label}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Col>
          <Col md='2'>
            <TextField
              id='paymentamount'
              label='Määrä'
              type='text'
              value={this.state.storageamount || ''}
              InputProps={{
                endAdornment: <InputAdornment position='end'></InputAdornment>,
              }}
              onChange={this.handleStorageAmount}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 20 }}>
          <Col md='8'>
            <TextField
              fullWidth
              id='saldodescription'
              label='Kuvaus'
              type='text'
              value={this.state.storagedescription || ''}
              onChange={this.handleStorageDescription}
            />
          </Col>
          <Col md='4'>
            <Button
              outline
              size='sm'
              color='success'
              disabled={!(this.state.storagewallet && this.state.storageamount && this.state.storagetype)}
              onClick={this.onSaveStoragePayment}
            >
              {this.state.savingstorage ? <Spinner size='sm' /> : 'Tallenna'}
            </Button>
            <Button outline color='primary' size='sm' onClick={this.toggleAddStorage}>
              Peruuta
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    )
  }

  renderAddStorageButton = () => {
    return (
      <Row style={{ marginTop: 5, marginBottom: 10 }}>
        <Col>
          <AddCircleIcon fontSize='small' onClick={this.toggleAddStorage} /> Lisää pankkiin/varastoon tapahtuma
        </Col>
      </Row>
    )
  }

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue })
  }

  // The integration flag is synced into venuemanagerfeatures by the backend; this app
  // only reads it. /integrations/{customerid} is not readable from here.
  // Nobody to notify means the notification setting has nothing to say. The Ohjaaja(t)
  // field sits directly above it, so picking a coach reveals the row.
  hasOrganisers = () => {
    const organisers = this.state.activity ? this.state.activity.organisers : null
    return !!(organisers && organisers.length > 0)
  }

  isPadelutionEnabled = () => {
    const features = this.props.customerdata ? this.props.customerdata.features : null
    return !!(features && features.integrations && features.integrations.padelution)
  }

  // activity.sport holds the sport's LABEL, not its key, and a venue can rename sports
  // in config/sports -- so resolve through the sports list rather than comparing the
  // string to 'Padel', which would hide the button for anyone who renamed it.
  isPadelActivity = () => {
    const sport = this.props.activity ? this.props.activity.sport : null
    if (!sport) return false
    const known = (this.state.sports || []).find((s) => s.label === sport)
    if (known) return known.key === 'padel'
    return String(sport).toLowerCase().indexOf('padel') > -1
  }

  showPadelutionButton = () => this.isPadelutionEnabled() && this.isPadelActivity()

  togglePadelutionDialog = (open) => this.setState({ padelutionDialogOpen: !!open })

  renderPadelutionDialog = () => (
    <PadelutionTournamentDialog
      open={this.state.padelutionDialogOpen}
      activity={this.props.activity}
      onClose={() => this.togglePadelutionDialog(false)}
    />
  )

  renderPadelutionButton = () => {
    if (!this.showPadelutionButton()) return null
    const participants = this.props.activity ? this.props.activity.participants : null
    return (
      <Col xs={12} md={4}>
        <Button
          variant='outlined'
          color='primary'
          disabled={!participants || participants.length === 0}
          onClick={() => this.togglePadelutionDialog(true)}
        >
          Luo turnaus Padelutioniin
        </Button>
      </Col>
    )
  }

  isReservationsEnabled = () => {
    const features = this.props.customerdata ? this.props.customerdata.features : null
    return !!(features && features.activityattaching)
  }

  // Tabs are conditional but carry fixed values, so the stored tabValue can point at a
  // tab that is not rendered (an external activity has no Osallistujat). MUI warns and
  // renders no indicator in that case, so fall back to the first tab.
  visibleTabValue = () => {
    const a = this.props.activity || {}
    const visible = [0]
    if (!a.isexternal) visible.push(1)
    if (a.hasqueue) visible.push(2)
    if (this.isReservationsEnabled()) visible.push(3)
    return visible.includes(this.state.tabValue) ? this.state.tabValue : 0
  }

  // Persists the reservation list onto the SAVED activity rather than the edited one,
  // so booking a court does not also commit unsaved Yleistiedot changes.
  handleReservationsChange = async (reservations) => {
    const saved = { ...this.props.activity, reservations }
    await this.props.firebase.updateActivity(saved)
    this.setState({ activity: { ...this.state.activity, reservations } })
    if (this.props.onUpdate) this.props.onUpdate()
  }

  renderAddMembershipRow = () => {
    if (this.state.showAddMembershipRow) {
      return (
        <>
          <Row style={{ marginTop: 10 }}>
            {this.state.membershipoptions.length > 0 ? (
              <Col md='4'>
                <FormControl style={{ width: '100%' }}>
                  <InputLabel id='membership'>Jäsenyys</InputLabel>
                  <Select
                    fullWidth
                    labelId='membership-label'
                    id='membership'
                    value={this.state.membershipselection || ''}
                    onChange={this.handleMembershipSelection}
                  >
                    {this.state.membershipoptions.map((v, i) => {
                      return (
                        <MenuItem key={'membrs' + i} value={v.id}>
                          {v.name}
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </Col>
            ) : null}
            <Col md='3'>
              <TextField
                id='membershipstart'
                label='Alkupäivä'
                type='date'
                variant='standard'
                value={this.state.membershipstart || moment.utc().format('YYYY-MM-DD')}
                onChange={this.handleMembershipStart}
              />
            </Col>
            <Col md='3'>
              <TextField
                id='membershipend'
                label='Loppupäivä'
                type='date'
                variant='standard'
                value={this.state.membershipend || moment.utc().endOf('year').format('YYYY-MM-DD')}
                onChange={this.handleMembershipEnd}
                disabled={this.state.membershippermanent}
              />
            </Col>
            <Col md='2'>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.membershippermanent}
                    onChange={this.handleMembershipPermanent}
                    name='membershippermanent'
                    color='primary'
                  />
                }
                label='Pysyvä'
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: 20 }}>
            <Col md='8'>
              <TextField
                fullWidth
                id='membershipnote'
                label='Muistiinpano'
                type='text'
                value={this.state.membershipnote || ''}
                onChange={this.handleMembershipNote}
              />
            </Col>
            <Col md='4'>
              <Button
                outline
                size='sm'
                color='success'
                disabled={!(this.state.membershipselection && this.state.membershipstart && this.state.membershipend)}
                onClick={this.onSaveMembership}
              >
                {this.state.savingmembership ? <Spinner size='sm' /> : 'Lisää'}
              </Button>
              <Button outline color='primary' size='sm' onClick={this.toggleAddMembership}>
                Peruuta
              </Button>
            </Col>
          </Row>
        </>
      )
    } else {
      return (
        <Row style={{ marginTop: 5, marginBottom: 10 }}>
          <Col md='1'>
            <AddCircleIcon fontSize='small' onClick={this.toggleAddMembership} />
          </Col>
          <Col>Lisää jäsenyys</Col>
        </Row>
      )
    }
  }

  renderAclsTab = () => {
    if (this.state.acls) {
      // console.log('this.state.acls', this.state.acls)
      return (
        <React.Fragment>
          {ACL_FIELDS.map((k, i) => {
            if (k === 'allowpostpayment') {
              return (
                <Row style={{ marginTop: 10 }} key={'acl' + i}>
                  <Col md='12'>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.acls[k]}
                          onChange={(e) => this.setAcl({ allowpostpayment: e.target.checked })}
                          color='primary'
                        />
                      }
                      label='Maksupakotuksen ohitus'
                    />
                  </Col>
                </Row>
              )
            } else if (k === 'blocked') {
              return (
                <Row style={{ marginTop: 10 }} key={'acl' + i}>
                  <Col md='12'>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.acls[k]}
                          onChange={(e) => this.setAcl({ blocked: e.target.checked })}
                          color='primary'
                        />
                      }
                      label='Varauskielto'
                    />
                  </Col>
                </Row>
              )
            } else if (k === 'blockedMessage') {
              return (
                <Row style={{ marginTop: 10 }} key={'acl' + i}>
                  <Col md='12'>
                    <TextField
                      fullWidth
                      id='blockedMessage'
                      label='Varauskiellon syy (näkyy käyttäjälle)'
                      type='text'
                      value={this.state.acls[k] || ''}
                      onChange={(e) => this.setState({ acls: { blockedMessage: e.target.value } })}
                    />
                    <Button
                      outline
                      color='primary'
                      size='sm'
                      onClick={() => this.setAcl({ blockedMessage: this.state.acls[k] })}
                    >
                      Tallenna viesti
                    </Button>
                  </Col>
                </Row>
              )
            }
            return null
          }).filter((v) => v)}
        </React.Fragment>
      )
    } else {
    }
  }

  renderMemberShipTab = () => {
    return (
      <React.Fragment>
        {this.renderPersonMemberships()}
        {this.renderAddMembershipRow()}
      </React.Fragment>
    )
  }

  handleMessageCollapse = (index) => {
    let open = this.state.messageopen
    open[index] = !open[index]
    this.setState({ messageopen: open })
  }

  renderMessages = () => {
    return this.state.messages.map((m, i) => {
      return (
        <React.Fragment key={'msg' + i}>
          <ListItem onClick={() => this.handleMessageCollapse(i)}>
            {this.state.messageopen && this.state.messageopen[i] ? <ExpandLess /> : <ExpandMore />}
            <ListItemText
              primary={m.subject}
              secondary={moment.unix(m.timestamp.seconds).format('DD.MM.YYYY HH:mm') + ' - ' + m.recipient}
            />
            {m.state === 'failed' ? (
              <ListItemSecondaryAction>
                <WarningIcon color='error' />
              </ListItemSecondaryAction>
            ) : null}
          </ListItem>
          <Collapse in={this.state.messageopen[i]} timeout='auto' unmountOnExit>
            <Row style={{ marginTop: 15, marginBottom: 30, marginLeft: 30 }}>
              <Col md='12'>
                <Typography variant='body1' color='textSecondary' component='pre'>
                  {m.body}
                </Typography>
              </Col>
            </Row>
          </Collapse>
          <Divider />
        </React.Fragment>
      )
    })
  }

  openMessageModal = (type, id) => {
    let _m = this.state.messaging
    _m.isOpen = !_m.isOpen
    _m.type = type
    if (type === 'passwordreset') {
      this.generatePasswordReset(id)
    }
    // const person = this.state.searchpersons.find((r) => r.id === id)
    this.setState({ messaging: _m })
  }

  generatePasswordReset = async (email) => {
    // console.log(email, ' to reset')
    let response = await this.props.firebase.getPasswordResetLink(email)
    // console.log(response)
    if (response.data.error) {
      this.setState({ passwordResetLink: response.data.error })
    } else {
      this.setState({ passwordResetLink: response.data.link })
    }
  }

  setNewEmail = (event) => {
    const newemail = event.target.value
    this.setState({ newemail })
  }

  setMessagebody = (event) => {
    let _m = this.state.messaging
    _m.body = event.target.value
    this.setState({ messaging: _m })
  }

  setMessageSubject = (event) => {
    let _m = this.state.messaging
    _m.subject = event.target.value
    if (_m.type === 'notification') {
      _m.toolong = event.target.value.length > 80
    }
    this.setState({ messaging: _m })
  }

  sendMessage = () => {
    this.setState({ sending: true })
    this.props.firebase
      .sendMessage(
        this.state.messaging.body,
        this.state.messaging.subject,
        this.props.person.email,
        this.props.person.id,
        ['usersearch']
      )
      .then((response) => {
        // console.log(response)
        this.closeMessageModal()
      })
  }

  sendConfirmation = () => {
    this.setState({ sending: true })
    this.props.firebase.sendConfirmation(this.state.newemail, this.props.person.id, 'fi').then((response) => {
      // console.log(response)
      this.closeMessageModal()
    })
  }

  closeMessageModal = () => {
    let _m = this.state.messaging
    _m.isOpen = false
    this.setState({ messaging: _m, passwordResetLink: 'Luodaan linkkiä ...', sending: false })
  }

  copyClicked = () => {
    this.setState({ copied: true })
    setTimeout(() => {
      this.setState({ copied: false })
    }, '6000')
  }

  createNewActivity = async (activity) => {
    const savedActivity = await this.props.firebase.createActivity(activity)
    this.props.onChangeActivity(savedActivity)
  }

  handleOptionLabel = (opt) => {
    return opt.firstname && opt.lastname ? opt.firstname + ' ' + opt.lastname : ''
  }

  handleParticipantChange = (event, value) => {
    this.setState({ newparticipant: value })
  }

  // Questions the activity asks at enrolment. A webshop customer answers these
  // themselves; an admin adding someone by hand would otherwise skip them.
  requiredExtraInfo = () => {
    const extrainfo = (this.props.activity && this.props.activity.extrainfo) || []
    return extrainfo.filter((question) => question && question.id && question.required)
  }

  addParticipants = async () => {
    if (this.requiredExtraInfo().length > 0) {
      this.setState({ extraInfoDialogOpen: true })
      return
    }
    this.saveParticipants()
  }

  // answers: { [participantId]: { [questionId]: answer } }
  saveParticipants = async (answers) => {
    const participants = this.state.newparticipant.map((participant) =>
      answers && answers[participant.id]
        ? { ...participant, extrainfo: answers[participant.id] }
        : participant
    )
    const activityid = this.props.activity.id
    this.setState({ saving: true })
    await this.props.firebase.addParticipantsToActivity(activityid, participants)
    this.setState({ newparticipant: [], saving: false, extraInfoDialogOpen: false })
    this.props.onUpdate()
  }

  renderExtraInfoDialog = () => (
    <ActivityParticipantExtraInfoDialog
      open={this.state.extraInfoDialogOpen}
      questions={(this.props.activity && this.props.activity.extrainfo) || []}
      participants={this.state.newparticipant}
      saving={this.state.saving}
      onCancel={() => this.setState({ extraInfoDialogOpen: false })}
      onConfirm={this.saveParticipants}
    />
  )

  toggleMessageDialog = (toparticipants) => {
    this.setState({ showmessagedialog: !this.state.showmessagedialog, toparticipants: toparticipants })
  }

  renderAddParticipant = () => {
    const { participants, maxp } = this.props.activity
    if (participants && participants.length >= maxp) {
      return (
        <React.Fragment>
          <Row>
            <Col xs={12} md={4}>
              <Button
                variant='contained'
                color='primary'
                disabled={
                  this.state.activity && this.state.activity.participants && this.state.activity.participants.length > 0
                    ? false
                    : true
                }
                onClick={() => {
                  this.toggleMessageDialog(true)
                }}
              >
                Lähetä viesti osallistujille
              </Button>
            </Col>
            {this.renderPadelutionButton()}
          </Row>
          {this.renderPadelutionDialog()}
          {this.renderExtraInfoDialog()}
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <Row>
            <Col xs={12} md={4}>
              <Autocomplete
                multiple
                options={this.state.searchresults ? this.state.searchresults : []}
                getOptionLabel={this.handleOptionLabel} // {option => option.name}
                onChange={this.handleParticipantChange}
                isOptionEqualToValue={(option, val) => {
                  return option.id === val.id
                }}
                value={this.state.newparticipant}
                onInputChange={(event, newInputValue) => {
                  if (newInputValue.length > 2) {
                    this.searchParticipants(newInputValue)
                  }
                }}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      variant='outlined'
                      label='Lisää osallistuja'
                      placeholder='Osallistuja'
                      margin='normal'
                    // fullWidth
                    />
                  )
                }}
                renderOption={(optionprops, option) => {
                  // MUI v5+ calls this with (props, option): the first argument is the li
                  // props, not the option. With the old single argument signature every row
                  // rendered blank, so the dropdown looked empty however many hits came back.
                  const { key, ...rest } = optionprops
                  const title = option.firstname && option.lastname ? option.firstname + ' ' + option.lastname : ''
                  return (
                    <li key={key || option.id} {...rest}>
                      <div>
                        <span>{title}</span>
                        <Typography variant='body2' color='textSecondary'>
                          {option.email}
                        </Typography>
                      </div>
                    </li>
                  )
                }}
              />
            </Col>
            <Col xs={12} md={4}>
              <Button
                variant='contained'
                color='primary'
                disabled={this.state.activity && this.state.activity.participants && this.state.activity.participants.length > 0 ? false : true}
                onClick={() => {
                  this.toggleMessageDialog(true)
                }}
              >Lähetä viesti osallistujille</Button>
            </Col>
            {this.renderPadelutionButton()}
          </Row>
          {this.renderPadelutionDialog()}
          {this.renderExtraInfoDialog()}
          {this.state.newparticipant && this.state.newparticipant.length > 0 && (
            <Row>
              <Col xs={12} md={4}>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    this.addParticipants()
                  }}
                >
                  {this.state.saving ? <Spinner size={'sm'} /> : 'Tallenna'}
                </Button>
              </Col>
            </Row>
          )}
        </React.Fragment>
      )
    }
  }

  handleQueueChange = (event, value) => {
    this.setState({ newqueued: value })
  }

  addQueued = async () => {
    let queued = this.state.newqueued
    let activityid = this.props.activity.id
    this.setState({ saving: true })
    await this.props.firebase.addQueuedToActivity(activityid, queued)
    this.setState({ newqueued: [], saving: false })
    this.props.onUpdate()
  }

  renderAddQueued = () => {
    const { hasqueue } = this.props.activity
    if (!hasqueue) return null
    return (
      <React.Fragment>
        <Row>
          <Col xs={12} md={4}>
            <Autocomplete
              multiple
              options={this.state.searchresults ? this.state.searchresults : []}
              getOptionLabel={this.handleOptionLabel} // {option => option.name}
              onChange={this.handleQueueChange}
              isOptionEqualToValue={(option, val) => {
                return option.id === val.id
              }}
              value={this.state.newqueued}
              onInputChange={(event, newInputValue) => {
                if (newInputValue.length > 2) {
                  this.searchParticipants(newInputValue)
                }
              }}
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    variant='outlined'
                    label='Lisää jonottajia'
                    placeholder='jonottaja'
                    margin='normal'
                    // fullWidth
                  />
                )
              }}
              renderOption={(optionprops, option) => {
                // Same v5+ (props, option) signature as the participants field above.
                const { key, ...rest } = optionprops
                const title = option.firstname && option.lastname ? option.firstname + ' ' + option.lastname : ''
                return (
                  <li key={key || option.id} {...rest}>
                    <div>
                      <span>{title}</span>
                      <Typography variant='body2' color='textSecondary'>
                        {option.email}
                      </Typography>
                    </div>
                  </li>
                )
              }}
            />
          </Col>
          <Col xs={12} md={4}>
            <Button
              variant='contained'
              color='primary'
              disabled={this.state.activity && this.state.activity.queue && this.state.activity.queue.length > 0 ? false : true}
              onClick={() => {
                this.toggleMessageDialog(false)
              }}
            >Lähetä viesti jonottajille</Button>
          </Col>
        </Row>
        {this.state.newqueued && this.state.newqueued.length > 0 && (
          <Row>
            <Col xs={12} md={4}>
              <Button
                variant='contained'
                color='primary'
                onClick={() => {
                  this.addQueued()
                }}
              >
                {this.state.saving ? <Spinner size={'sm'} /> : 'Tallenna'}
              </Button>
            </Col>
          </Row>
        )}
      </React.Fragment>
    )
  }

  render() {
    if (!this.props.activity) {
      return (
        <ActivityCreator
          onCreate={
            this.props.recurrent ? this.props.firebase.createRecurrentActivity : this.props.firebase.createActivity
          }
          initialActivity={this.props.initialActivity}
          initialWeekday={this.props.initialWeekday}
          followStart={this.props.followStart}
          activitytypes={this.state.activitytypes}
          sports={this.state.sports}
          images={this.props.images}
          recurrent={this.props.recurrent}
        />
      )
    }
    const a = this.props.activity
    if (this.state.templateDraft) return this.renderTemplateDraft()
    return (
      <div style={{ padding: 20, backgroundColor: 'white' }}>
        <Row>
          <Col>
            <Typography variant='h4' gutterBottom>
              {a.name.fi}
            </Typography>
          </Col>
          {this.canSaveAsTemplate() ? (
            <Col xs='auto' className='text-right'>
              <Button size='sm' outline color='primary' onClick={this.openTemplateDraft}>
                Tallenna pohjaksi
              </Button>
              {this.state.templateSaved ? (
                <Typography variant='caption' color='textSecondary' display='block'>
                  Pohja tallennettu
                </Typography>
              ) : null}
            </Col>
          ) : null}
        </Row>
        {/* <Row>
          <Col>
            <MuiButton
              variant='outlined'
              size='small'
              onClick={(el) => {
                this.openMessageModal('call', id)
              }}
            >
              <PhoneIcon fontSize='small' /> Soita
            </MuiButton>{' '}
            <MuiButton
              variant='outlined'
              size='small'
              onClick={(el) => {
                this.openMessageModal('email', email)
              }}
            >
              <MailOutlineIcon fontSize='small' /> Lähetä email
            </MuiButton>{' '}
            <MuiButton
              variant='outlined'
              size='small'
              onClick={(el) => {
                this.openMessageModal('passwordreset', email)
              }}
            >
              <VpnKeyIcon fontSize='small' /> Salasanan vaihto
            </MuiButton>{' '}
            <MuiButton
              variant='outlined'
              size='small'
              onClick={(el) => {
                this.openMessageModal('emailchange', id)
              }}
            >
              <AlternateEmailIcon fontSize='small' /> Vaihda email
            </MuiButton>
          </Col>
        </Row> */}
        <Row className='mt-2 border-bottom mb-2'>
          <Col>
            <Tabs
              value={this.visibleTabValue()}
              indicatorColor='primary'
              // textColor="primary"
              onChange={this.handleTabChange}
              // aria-label="disabled tabs example"
              variant='scrollable'
            >
              <Tab label='Yleistiedot' value={0} />
              {!a.isexternal && <Tab label='Osallistujat' value={1} />}
              {a.hasqueue && <Tab label='Jono' value={2} />}
              {this.isReservationsEnabled() && <Tab label='Varaukset' value={3} />}
              {/* <Tab label='Viestit' />
              <Tab label='Oikeudet' />
              <Tab label='Laskutettavaa' />
              <Tab label='Laskut' /> */}
            </Tabs>
          </Col>
        </Row>
        <Row>
          <Col>
            <TabPanel value={this.state.tabValue} index={0}>
              {this.renderActivityGeneralData()}
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={1}>
              {this.renderParticipationDeadlines()}
              {this.renderAddParticipant()}
              {this.renderActivityParticipants()}
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={2}>
              {this.renderAddQueued()}
              {this.renderActivityQueue()}
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={3}>
              {this.isReservationsEnabled() ? (
                <ActivityReservations
                  activity={this.props.activity}
                  resources={this.props.customerdata ? this.props.customerdata.resources : []}
                  firebase={this.props.firebase}
                  onReservationsChange={this.handleReservationsChange}
                />
              ) : null}
            </TabPanel>
          </Col>
        </Row>
        <ActivityReservationSyncDialog
          open={!!this.state.driftDialogActivity}
          activity={this.state.driftDialogActivity}
          reservations={this.state.driftedList}
          firebase={this.props.firebase}
          moving={this.state.movingReservations}
          onLeave={this.closeDriftDialog}
          onMove={this.moveDriftedReservations}
        />
        <ActivityReservationReleaseDialog
          open={this.state.releaseDialogOpen}
          reservations={createdReservations(this.state.activity.reservations)}
          working={this.state.releasing}
          onCancel={this.closeReleaseDialog}
          onKeep={this.closeReleaseDialog}
          onRelease={this.releaseReservations}
        />
        <Modal size='sm' isOpen={this.state.loadingModalOpen} toggle={this.toggleLoadingModal} backdrop={'static'}>
          <ModalBody>
            <Spinner />
          </ModalBody>
        </Modal>
        <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={!!this.state.removePersonConfirmation}
          onClose={this.toggleRemoveDialog}
          aria-labelledby='max-width-dialog-title'
          style={{ zIndex: '1000' }}
        >
          <DialogTitle id='max-width-dialog-title'>Vahvista poisto</DialogTitle>
          <DialogContent>
            Oletko aivan varma, että haluat poistaa asiakkuuden tältä käyttäjältä? Muista tarkistaa onko käyttäjällä
            maksamattomia varauksia ennen kuin poistat asiakkuuden. Poistamiseen menee hetken aikaa jonka jälkeen
            henkilö ei löydy enää hausta.
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.removeCustomershipFromPerson()} color='danger'>
              Poista asiakkuus (piilota)
            </Button>
            <Button onClick={this.toggleRemoveDialog} color='primary'>
              Sulje
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={!!(this.state.edits && this.state.edits.posterEditOpen)}
          onClose={this.togglePosterEdit}
          aria-labelledby='max-width-dialog-title'
          style={{ zIndex: '1000' }}
        >
          <DialogTitle id='max-width-dialog-title'>Valitse kuva</DialogTitle>
          <DialogContent>
            <ImageSelector images={this.props.images} onSelect={this.handlePosterChange} />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.togglePosterEdit} color='primary'>
              Sulje
            </Button>
          </DialogActions>
        </Dialog>
        <MessageDialog onClose={this.toggleMessageDialog} open={!!this.state.showmessagedialog} recipientids={this.state.toparticipants ? this.state.activity?.participants?.map((a) => a.id) : this.state.activity?.queue?.map((a) => a.id) } />
        <RecurrentEditDialog
          open={this.state.recurrentEditDialogOpen}
          onClose={this.handleRecurrentEditClose}
          onConfirm={this.handleRecurrentEditConfirm}
          activityName={this.state.activity?.name?.fi}
          loading={this.state.recurrentEditLoading}
          error={this.state.recurrentEditError}
          timingEdited={TIMING_FIELDS.some((field) => (this.state.activityEdits || {})[field])}
        />
      </div>
    )
  }
  // }
}

export default withFirebase(ActivityDetailsWizard)
